"use client";
import { Button } from "@/components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import Fade from "embla-carousel-fade";
import { useLocale, useTranslations } from "next-intl";
import Link from "next/link";

const slides = [
  {
    title_fr: "Matériel informatique pour les professionnels",
    title_ar: "معدات معلوماتية للمحترفين",
    title_en: "IT Hardware for Professionals",
    description_fr:
      "Découvrez notre sélection d’ordinateurs, imprimantes, périphériques et réseaux adaptés à vos besoins professionnels.",
    description_ar:
      "اكتشف مجموعتنا من الحواسيب والطابعات والملحقات والشبكات المصممة لاحتياجاتك المهنية.",
    description_en:
      "Explore our range of computers, printers, peripherals, and networking solutions tailored to your professional needs.",
    image: "light-materiel-pro.webp",
  },
  {
    title_fr: "30 ans d’expérience en matériel informatique",
    title_ar: "30 سنة من الخبرة في مجال المعدات المعلوماتية",
    title_en: "30 Years of Experience in IT Hardware",
    description_fr:
      "Nous conseillons et équipons entreprises et particuliers avec du matériel fiable, performant et durable.",
    description_ar:
      "نقوم بتقديم المشورة والتجهيز للمؤسسات والأفراد بمعدات موثوقة وفعالة وطويلة الأمد.",
    description_en:
      "We provide guidance and supply hardware to businesses and individuals with reliable, high-performance equipment.",
    image: "light-materiel-pro-1.webp",
  },
  {
    title_fr: "Des solutions matérielles prêtes à l’emploi",
    title_ar: "حلول جاهزة من المعدات المعلوماتية",
    title_en: "Ready-to-Use Hardware Solutions",
    description_fr:
      "Ordinateurs montés, postes de travail, accessoires : tout pour une installation rapide et efficace.",
    description_ar:
      "حواسيب مركبة، محطات عمل، ملحقات: كل ما تحتاجه لتركيب سريع وفعال.",
    description_en:
      "Pre-assembled computers, workstations, and accessories for fast and efficient setup.",
    image: "light-materiel-pro-2.webp",
  },
];

export default function HeroCarousel() {
  const locale = useLocale();
  const t = useTranslations("hero");
  const plugins = [Autoplay({ delay: 3000 }), Fade()];
  const options = { loop: true };
  return (
    <Carousel
      opts={options}
      plugins={plugins}
      className="relative h-full w-full"
    >
      <CarouselContent className="h-[600px] lg:h-[800px]">
        {slides.map((slide, index) => (
          <CarouselItem key={index} className="relative">
            <div
              className="absolute inset-0 h-[600px] bg-cover bg-center lg:h-[800px]"
              style={{ backgroundImage: `url(/${slide.image})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-white" />
            <div className="relative top-1/2 flex w-full -translate-y-1/2 flex-col items-center gap-5 px-5 text-center lg:w-3/5 lg:items-start lg:px-0 ltr:lg:left-[15%] ltr:lg:text-left rtl:lg:right-[15%] rtl:lg:text-right">
              <h2 className="ltr:font-title text-balance text-3xl font-bold text-white lg:text-7xl lg:ltr:tracking-wide">
                {locale === "fr"
                  ? slide.title_fr
                  : locale === "ar"
                    ? slide.title_ar
                    : slide.title_en}
              </h2>
              <p className="text-xl font-medium text-white">
                {locale === "fr"
                  ? slide.description_fr
                  : locale === "ar"
                    ? slide.description_ar
                    : slide.description_en}
              </p>
              <Button className="w-fit border-white text-base font-semibold text-white hover:bg-white hover:text-primary">
                <Link href="/catalog">{t("catalogButton")}</Link>
              </Button>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="absolute left-5 top-1/2 z-10 hidden h-12  w-12 items-center justify-between rounded-full bg-white/10 p-4 text-white hover:bg-white/20 lg:flex" />
      <CarouselNext className="absolute right-5 top-1/2 hidden h-12 w-12 items-center justify-between rounded-full bg-white/10 p-4 text-white hover:bg-white/20 lg:flex" />
    </Carousel>
  );
}
